import {useContext, useEffect, useState} from "react";
import {ApiContext} from "../util/Requests";
import StackHolder from "../components/StackHolder";
import ContentStack from "../components/filters/ContentStack";
import FilterStack from "../components/filters/FilterStack";
import PaginationFilter from "../components/filters/PaginationFilter";
import {SC_PaginationState} from "../util/api/filters/SC_PaginationState";
import {useSearchParams} from "react-router-dom";
import FilterRibbon from "../components/filters/FilterRibbon";
import {SC_User} from "../util/api/SC_User";
import FontAwesomeButton from "../components/cards/FontAwesomeButton";
import {faUpload} from "@fortawesome/free-solid-svg-icons/faUpload";
import {UPLOAD_FILE_TYPE_REPORT} from "../components/editable_entries/EditableCardEntryFile";
import {toast} from "react-toastify";
import {readfile} from "../util/FilesUtil";
import EmployeeFilter from "../components/filters/EmployeeFilter";
import {SC_EmployeeFilter} from "../util/api/filters/SC_EmployeeFilter";
import PageWrapper from "../components/PageWrapper";
import {faUsersGear} from "@fortawesome/free-solid-svg-icons/faUsersGear";
import UserCard from "../components/UserCard";


const UserManagementPage = ({}) => {
    const [params, setParams] = useSearchParams();

    const { caches, doRequest, startLoading, stopLoading } = useContext(ApiContext);

    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [maxPage, setMaxPage] = useState(0);

    useEffect(() => {
        caches.employees.update();
    }, [])

    /**
     * @type {false|SC_EmployeeFilter}
     */
    let eFilter;
    let setEFilter;
    [eFilter, setEFilter] = useState(new SC_EmployeeFilter());

    /**
     * @type {false|SC_PaginationState}
     */
    let paginate;
    let setPaginate;
    [paginate, setPaginate] = useState(false);

    useEffect(() => {
        const scPaginate = SC_PaginationState.fromURL(params);
        const scEmployeeFilter = SC_EmployeeFilter.fromURL(params);

        setPaginate(scPaginate);
        setEFilter(scEmployeeFilter);
    }, [params]);

    useEffect(() => {
        if (!caches.employees.value || !paginate)
            return;

        const filtert = caches.employees.value.filter(emp => emp.paycomID).filter(e => eFilter.applyToUser(e));
        const maxx = Math.ceil(filtert.length / paginate.size);
        setMaxPage(maxx);
        // setPaginate(paginate.clone().merge(new SC_PaginationState({page: Math.min(Math.max(0, paginate.page), maxx - 1)})))
        setFilteredEmployees(filtert.sort(SC_User.sortUsers).slice(...paginate.toSlice()));
    }, [caches.employees.value, paginate, eFilter]);

    const onPagEdit = (v) => {
        let newPag = paginate.clone();
        newPag.merge(new SC_PaginationState(v));
        setPaginate(newPag);

        setParams(newPag.toURL(params), {replace: true});
    }

    async function fileUploadWrapped(fs) {
        if (!fs.length) {
            console.error("No file upload found.");
            return;
        }

        let f = fs[0];

        let contents = await readfile(f);

        let formData = new FormData();

        formData.append("csv-contents", contents);

        let back = await doRequest(formData, "upload_employee_dump");

        if (back.code === 200)
            await caches.employees.update();
    }

    async function reportfileUploadWrapped(fs) {
        if (!fs.length) {
            console.error("No file upload found.");
            return;
        }

        let f = fs[0];

        let contents = await readfile(f);

        let formData = new FormData();

        formData.append("csv-contents", contents);

        let back = await doRequest(formData, "upload_reports_to_report");

        if (back.code === 200)
            await caches.employees.update();
    }

    function onFileUpload(fs) {
        startLoading();

        fileUploadWrapped(fs).then(() => {
            stopLoading();
        }).catch((err) => {
            stopLoading();
            toast.error(err.message);
        });
    }

    function reportonFileUpload(fs) {
        startLoading();

        reportfileUploadWrapped(fs).then(() => {
            stopLoading();
        }).catch((err) => {
            stopLoading();
            toast.error(err.message);
        });
    }

    return (
        <PageWrapper>
        <StackHolder>
            <FilterStack footerContent={<>
                <FilterRibbon onClear={() => {
                    setEFilter(new SC_EmployeeFilter());
                    setPaginate(SC_PaginationState.basicEmpty());
                }} bonusContent={<div style={{float: ""}}>
                    <label>
                        <FontAwesomeButton icon={faUpload}/>
                        <input type={"file"} style={{display: "none"}} accept={UPLOAD_FILE_TYPE_REPORT} onChange={(e) => onFileUpload(e.target.files)}/>
                    </label>
                    <label>
                        <FontAwesomeButton icon={faUsersGear}/>
                        <input type={"file"} style={{display: "none"}} accept={UPLOAD_FILE_TYPE_REPORT} onChange={(e) => reportonFileUpload(e.target.files)}/>
                    </label>
                </div>} /></>}>
                <EmployeeFilter filter={eFilter} onEdit={(v) => {
                    console.log(v);
                    setEFilter(eFilter.clone().merge(new SC_EmployeeFilter(v)))
                }} />
                <PaginationFilter maxPage={maxPage} filter={paginate} onEdit={onPagEdit}/>
            </FilterStack>
            <ContentStack>
                {filteredEmployees.map(employee => <UserCard key={employee.paycomID} user={employee}/>)}
            </ContentStack>
        </StackHolder>
        </PageWrapper>
    )
};

export default UserManagementPage;